import { css } from "styled-components"

export const interactiveCSS = css`
  cursor: pointer;
  user-select: none;
`
